import React, {useEffect, useState} from "react";
import CardProduct from "components/CardProduct";
import MarketingMatItem from "pages/VinCheck/components/MarketingMatItem";

interface IProps {
  recommendProducts: any[];
}

const RecommendProducts: React.FC<IProps> = ({ recommendProducts }) => {
  return (
    <React.Fragment>
      {recommendProducts.map((item, index: number) => item.no || item.no === 0
        ? (
          <MarketingMatItem
            key={item.no}
            id={item.no}
            url={item.link}
            name={item.name}
            description={item.description}
          />
        )
        : (
          <CardProduct {...item} key={`p_${item.id}`} />
        )
      )}
    </React.Fragment>
  );
};

export default RecommendProducts;
